import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=e948704e&scoped=true"
import script from "./Accept.vue?vue&type=script&lang=ts"
export * from "./Accept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e948704e",
  null
  
)

export default component.exports